
<div *ngIf="selectedBusinessUnit"
     class="box-dash">
  <!--style added by suraj-->
  <!--<div class=" row view-options">
    <div class="col-md-12">
      <div class="form-group pagination-container">
        <label class="pagination-results">
          <pagination-label pageSize="{{queryContainer.query.pageSize}}"
                            currentPage="{{queryContainer.query.currentPage}}}"
                            totalRecords="{{queryContainer.query.totalRecords}}"></pagination-label>
        </label>
        <nbc-pagination totalItems="{{queryContainer.query.totalRecords}}"
                        itemsPerPage="{{queryContainer.query.pageSize}}"></nbc-pagination>
      </div>
    </div>-->
  <tabset appDisableRightClick>
    <tab #tabActiveTs="tab"
         customClass="btn btn-default"
         style="padding:0;"
         active="true"
         (selectTab)="onActiveTimesheets()"
         heading="Active Timesheets">
      <div class="tpm-box-dash-hdr-bar" style="cursor:default;">
        <h2 class="tpm-box-dash-hdr_tab_ng_upgrade">{{selectedBusinessUnit.displayName}}</h2>
      </div>
    </tab>
    <tab #tabCompletedTs="tab"
         customClass="btn btn-default"
         style="padding:0;"
         (selectTab)="onCompltedTimesheets()"
         (onDestroy)="dashboardData=null"
         heading="Completed Timesheets">
      <div class="tpm-box-dash-hdr-bar"  style="cursor:default;">
        <h2 class="tpm-box-dash-hdr_tab_ng_upgrade">{{selectedBusinessUnit.displayName}}</h2>
      </div>
    </tab>
    <tab #tabReportTs="tab" customClass="btn btn-default"
         style="padding:0;"
         authenticate-user="TPMReports.Retrieve"
         authenticate-command="hide" select="hideGrid()" (selectTab)="onReportTab()" heading="Reports">
      <div class="tpm-box-dash-hdr-bar"  style="cursor:default;">
        <h2 class="tpm-box-dash-hdr_tab_ng_upgrade">{{selectedBusinessUnit.displayName}}</h2>
      </div>

    </tab>
    <tab *ngIf="operationTalentDept" #tabTemplate="tab"
         customClass="btn btn-default"
         style="padding:0;"
         authenticate-user="TPM.ManageTemplate.Retrieve"
         authenticate-command="hide" (selectTab)="onTimecardTab()" heading="Timecard Templates">
      <div class="tpm-box-dash-hdr-bar"  style="cursor:default;">
        <h2 class="tpm-box-dash-hdr_tab_ng_upgrade">{{selectedBusinessUnit.displayName}}</h2>
      </div>
      <div class="talent-payroll" style="background-color:#ffffff;cursor:default;">
        <tpm-template-layout *ngIf="tabTemplate.active"></tpm-template-layout>
      </div>
    </tab>
  </tabset>
  <div class="row talent-payroll" *ngIf="!dashboardListItems.length" style="background-color: white;" >
    <div class="col-lg-16">
      <div class="page-container">
        <div class="container-fluid">
          <div class="tpm-page-content">
            <div class="row payroll-timesheet-table">
              <div class="col-md-12" *ngIf="result">
                <p *ngIf="!dashboardListItems.length ">No Results.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class=" row view-options" *ngIf="pagination_display && dashboardListItems.length ">
    <div class="col-md-12">
      <div class="form-group pagination-container d-flex pull-right" style="padding-right:36px;padding-top:20px;">
        <label class="pagination-results">
          <pagination-label pageSize="{{queryContainer.query.pageSize}}"
                            currentPage="{{queryContainer.query.currentPage}}"
                            totalRecords="{{queryContainer.query.totalRecords}}"></pagination-label>
      </label>
      <nbc-pagination totalItems="{{queryContainer.query.totalRecords}}"
                      itemsPerPage="{{queryContainer.query.pageSize}}"
                      [currentPage]="queryContainer.query.currentPage"
                      (pageChanged)="eventSearch($event)"></nbc-pagination>
      </div>
    </div>
  </div>

  <ts-card-grid *ngIf="dashboardData && dashboardData.items && tabCompletedTs.active"
                [tsSummary]="dashboardData"
                [buAccess]="buAccess">


  </ts-card-grid>
  <ts-card-grid *ngIf="dashboardData && dashboardData.items && tabActiveTs.active"
                [tsSummary]="dashboardData"
                [buAccess]="buAccess"></ts-card-grid>

  <app-report-layout *ngIf="dashboardData && dashboardData.items && tabReportTs.active"
                     [tsSummary]="dashboardData"
                     [buAccess]="buAccess"></app-report-layout>




</div>

